import { Link } from 'react-router-dom';

const services = [
  { n: '01', name: 'Cuts & styling', desc: 'Women, men, and kids, plus blow-dry styling.', img: '/images/mens-150x150.jpeg' },
  { n: '02', name: 'Color & highlights', desc: 'Full color, highlights, lowlights, and touch-ups.', img: '/images/color-150x150.jpeg' },
  { n: '03', name: 'Balayage, ombré & keratin', desc: 'Lived-in color, smoothing keratin, and perms.', img: '/images/rosegold-150x150.jpeg' },
  { n: '04', name: 'Color correction & vivids', desc: 'Fixes, bold vivids, and extensions.', img: '/images/rainbow-150x150.jpeg' },
  { n: '05', name: 'Bridal & up-dos', desc: 'Up-do styling, bridal hair, and makeup.', img: '/images/bridal1-150x150.jpeg' },
];

const work = [
  { src: '/images/color-150x150.jpeg', alt: 'Rich all-over color' },
  { src: '/images/highlights-150x150.jpeg', alt: 'Soft natural highlights' },
  { src: '/images/rosegold-150x150.jpeg', alt: 'Rose-gold balayage' },
  { src: '/images/Selena-pink-hair-150x150.jpeg', alt: 'Vivid pink color' },
  { src: '/images/silver-150x150.jpeg', alt: 'Silver toned color' },
  { src: '/images/aline-150x150.jpeg', alt: 'Sharp A-line cut' },
  { src: '/images/rainbow-150x150.jpeg', alt: 'Multi-tone vivid color' },
  { src: '/images/bridal2-150x150.jpeg', alt: 'Bridal up-do' },
];

const teamTeaser = [
  { name: 'Alysa', img: '/images/alysa.jpg' },
  { name: 'Victoria', img: '/images/victoria.jpg' },
  { name: 'Kayla', img: '/images/kayla.jpg' },
  { name: 'Stacie', img: '/images/stacie.jpg' },
];

const Home = () => (
  <div className="page">
    {/* Hero */}
    <section className="hero section--dark grain">
      <div className="container hero__inner">
        <div className="hero__copy">
          <span className="kicker reveal">Independent Hair Salon · Temecula</span>
          <h1 className="hero__title reveal" data-reveal="60">
            Make everyday a<br />
            beautiful day.
          </h1>
          <p className="lede hero__lede reveal" data-reveal="140">
            The Loft is an independent hair salon in the heart of Temecula wine
            country. A team of stylists, one warm room, and every kind of hair, from a
            quick trim to a full balayage or vivid color transformation.
          </p>
          <div className="btn-row reveal" data-reveal="220">
            <Link to="/team" className="btn btn--primary">Find your stylist</Link>
            <Link to="/contact" className="btn btn--outline">Visit the salon</Link>
          </div>
          <p className="hero__meta reveal" data-reveal="300">
            Mon–Sat, 10–5 · Walk-ins welcome, appointments encouraged
          </p>
        </div>

        <div className="hero__media reveal" data-reveal="180">
          <div className="hero__arch hero__arch--main arch">
            <img src="/images/eufora-wall-hero.webp" alt="The Loft Salon's Eufora retail product wall" />
          </div>
          <div className="hero__arch hero__arch--alt arch">
            <img src="/images/salon2.jpeg" alt="Styling chairs and mirrors at The Loft" />
          </div>
          <div className="hero__chip frame">
            <img src="/images/rosegold-150x150.jpeg" alt="Rose-gold balayage by a Loft stylist" />
          </div>
        </div>
      </div>
    </section>

    {/* Welcome */}
    <section className="section">
      <div className="container welcome">
        <div className="welcome__intro">
          <span className="kicker reveal">Welcome in</span>
          <h2 className="reveal" data-reveal="60">
            A salon that feels like Temecula: warm, unhurried, a little
            sun-soaked.
          </h2>
        </div>
        <div className="welcome__body reveal" data-reveal="120">
          <p>
            The Loft sits on the second floor of Vineyard Commons, streetside and
            full of light. Our stylists are independent pros who set their own
            chairs and their own schedules, so the person who cuts your hair is
            the person you build a rapport with, visit after visit.
          </p>
          <p>
            Come in for a clean everyday cut, the color you have been saving on
            your phone for months, or a correction from somewhere that went
            sideways. There is a chair here for it.
          </p>
          <dl className="facts">
            <div className="facts__item">
              <dt>Independent</dt>
              <dd>stylists & colorists</dd>
            </div>
            <div className="facts__item">
              <dt>Mon–Sat</dt>
              <dd>10am to 5pm</dd>
            </div>
            <div className="facts__item">
              <dt>Walk-ins</dt>
              <dd>welcome, book ahead</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>

    {/* Services overview */}
    <section className="section--tight section--warm">
      <div className="container">
        <div className="section-head reveal">
          <span className="kicker">What we do</span>
          <h2>Every kind of hair, done with care.</h2>
          <p className="lede">
            From the simplest cut to a full color correction, here is the range
            you will find across our chairs.
          </p>
        </div>

        <ul className="svc-list">
          {services.map((s, i) => (
            <li className="svc-row reveal" data-reveal={i * 70} key={s.name}>
              <span className="svc-row__n">{s.n}</span>
              <div className="svc-row__thumb arch">
                <img src={s.img} alt="" loading="lazy" />
              </div>
              <div className="svc-row__text">
                <h3>{s.name}</h3>
                <p>{s.desc}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className="svc-list__cta reveal">
          <Link to="/services" className="btn btn--ghost">
            See all services <span className="arrow">→</span>
          </Link>
        </div>
      </div>
    </section>

    {/* Featured work */}
    <section className="section">
      <div className="container">
        <div className="section-head section-head--center reveal">
          <span className="kicker">Recent work</span>
          <h2>Color we are proud of.</h2>
          <p className="lede">
            A small slice of what walks out of The Loft. The stylists behind it
            are a tap away.
          </p>
        </div>

        <div className="work-strip reveal">
          {work.map((w) => (
            <figure className="work-strip__item frame" key={w.src}>
              <img src={w.src} alt={w.alt} loading="lazy" />
            </figure>
          ))}
        </div>

        <div className="text-center reveal" style={{ marginTop: 'var(--space-8)' }}>
          <Link to="/team" className="btn btn--ghost">
            Meet the stylists behind it <span className="arrow">→</span>
          </Link>
        </div>
      </div>
    </section>

    {/* Team teaser */}
    <section className="section--tight section--warm">
      <div className="container team-teaser">
        <div className="team-teaser__head reveal">
          <span className="kicker">The team</span>
          <h2>Every stylist, their own specialty.</h2>
          <p className="lede">
            Each stylist keeps their own book and their own portfolio. Find the
            one whose work looks like the hair you want, then reach out directly.
          </p>
          <Link to="/team" className="btn btn--primary">Find your stylist</Link>
        </div>
        <div className="team-teaser__grid">
          {teamTeaser.map((m, i) => (
            <Link to="/team" className="team-card reveal" data-reveal={i * 70} key={m.name}>
              <div className="team-card__img arch">
                <img src={m.img} alt={`${m.name}, stylist at The Loft Salon`} loading="lazy" />
              </div>
              <span className="team-card__name">{m.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>

    {/* Products */}
    <section className="section">
      <div className="container products-teaser">
        <div className="products-teaser__media reveal">
          <figure className="products-teaser__photo frame">
            <img
              src="/images/eufora-sign.jpg"
              alt="The illuminated Eufora sign and Edison-bulb lighting on the salon's brick wall"
              loading="lazy"
            />
          </figure>
        </div>
        <div className="products-teaser__copy reveal" data-reveal="120">
          <span className="kicker">In the salon</span>
          <h2>We finish every look with Eufora.</h2>
          <p className="lede">
            Plant-based, salon-only care for color-treated, curly, fine, and
            thinning hair. We will match you to the line that keeps your style
            looking like it did the day you left the chair.
          </p>
          <Link to="/products" className="btn btn--ghost">
            See the Eufora lines <span className="arrow">→</span>
          </Link>
        </div>
      </div>
    </section>

    {/* Booth rental CTA */}
    <section className="section--tight section--dark grain cta-band">
      <div className="container cta-band__inner">
        <div className="reveal">
          <span className="kicker">For stylists</span>
          <h2>Rent a chair at The Loft.</h2>
          <p className="lede">
            Full-time and part-time booth rentals for licensed stylists who want
            a warm room, good light, and their own book.
          </p>
        </div>
        <Link to="/booths" className="btn btn--primary reveal" data-reveal="120">
          Booth rental details
        </Link>
      </div>
    </section>

    {/* Visit */}
    <section className="section visit">
      <div className="container visit__inner">
        <div className="visit__copy reveal">
          <span className="kicker">Come see us</span>
          <h2>31217 Pauba Rd, Suite 202</h2>
          <p className="lede">
            Vineyard Commons, second floor, streetside. Temecula, CA 92592.
            Appointments are encouraged; walk-ins are welcome.
          </p>
          <div className="btn-row">
            <a
              className="btn btn--primary"
              href="https://maps.google.com/?q=31217+Pauba+Rd+Suite+202+Temecula+CA+92592"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get directions
            </a>
            <Link to="/contact" className="btn btn--outline">Contact the salon</Link>
          </div>
        </div>
        <div className="visit__hours reveal" data-reveal="120">
          <div className="visit__row">
            <span>Mon – Sat</span>
            <span>10:00am – 5:00pm</span>
          </div>
          <div className="visit__row">
            <span>Sunday</span>
            <span>Closed</span>
          </div>
          <div className="visit__row">
            <span>Phone</span>
            <span><a className="link" href="tel:9516946016">(951) 694-6016</a></span>
          </div>
          <div className="visit__row">
            <span>Email</span>
            <span><a className="link" href="mailto:theloftsalon@tlst.us">theloftsalon@tlst.us</a></span>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Home;
